<div *ngIf="!isServer" [ngClass]="getLevelClass()">
  <ng-container *ngIf="isAdvisor || ownerEmailIsAccountEmail">
    <div class="verify-email-container">
      <div class="label-basic">
        <div *ngIf="differentFromInsured" class="label-basic__text">
          You are almost done. Before we finish, please make sure the emails below are correct.
        </div>
        <div *ngIf="!differentFromInsured" class="label-basic__text">
          You are almost done. Before we finish, please make sure the email below is correct.
        </div>
      </div>
      <div *ngIf="!differentFromInsured" class="entry-field">
        <label class="entry-field__label">
          {{ mainPolicyOwner.ownerFirstName }} is the owner and the insured. {{ mainPolicyOwner.ownerFirstName }}'s
          email is:
        </label>
        <div>
          <input type="text" class="entry-field__input" [(ngModel)]="mainPolicyOwner.ownerEmail" disabled />
        </div>
        <a *ngIf="!isAdvisor" class="email-code__edit email-code__edit--underlined" routerLink="/settings">Edit</a>
      </div>
      <ng-container *ngIf="differentFromInsured">
        <div class="entry-field" *ngIf="!customer.application.primaryPolicy.insuredIsJuvenile()">
          <label class="entry-field__label">
            {{ insuredName }}
            {{ policy.jointOwnerIsInsured() ? ' is a joint owner and the insured. ' : ' is the insured. ' }}
            {{ insuredName }}'s email is:
          </label>
          <div>
            <input type="text" class="entry-field__input" [(ngModel)]="insuredEmail" disabled />
          </div>
        </div>
        <div class="entry-field">
          <label class="entry-field__label">
            {{ mainPolicyOwner.ownerFirstName }}
            {{ policy.jointOwnerIsInsured() ? ' is a joint owner. ' : ' is the owner. ' }}
            {{ mainPolicyOwner.ownerFirstName }}'s email is:
          </label>
          <div>
            <input type="text" class="entry-field__input" [(ngModel)]="mainPolicyOwner.ownerEmail" disabled />
          </div>
          <a *ngIf="!isAdvisor" class="email-code__edit email-code__edit--underlined" routerLink="/settings">Edit</a>
        </div>
      </ng-container>
      <div *ngFor="let owner of owners" class="entry-field">
        <label class="entry-field__label">
          {{ owner.ownerFirstName }} {{ typeOfOwner }}. {{ owner.ownerFirstName }}'s email is:
        </label>
        <div>
          <input type="text" class="entry-field__input" [(ngModel)]="owner.ownerEmail" disabled />
        </div>
        <a *ngIf="!isAdvisor" class="email-code__edit email-code__edit--underlined" routerLink="/settings">Edit</a>
      </div>
      <div *ngIf="juvenileHasSigner" class="entry-field">
        <label class="entry-field__label">
          {{ signerFirstName }} is {{ insuredName }}'s signer. {{ signerFirstName }}'s email is:
        </label>
        <div>
          <input type="text" class="entry-field__input" [(ngModel)]="signerEmail" disabled />
        </div>
        <a *ngIf="!isAdvisor" class="email-code__edit email-code__edit--underlined" routerLink="/settings">Edit</a>
      </div>
      <div *ngIf="payerEmail" class="entry-field">
        <label class="entry-field__label">
          {{ payerFirstName }} is the premium payer. {{ payerFirstName }}'s email is:
        </label>
        <div>
          <input type="text" class="entry-field__input" [(ngModel)]="payerEmail" disabled />
        </div>
        <a *ngIf="!isAdvisor" class="email-code__edit email-code__edit--underlined" routerLink="/settings">Edit</a>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!isAdvisor && !ownerEmailIsAccountEmail && !isLifeBridge">
    <div class="label-basic verify-owner-email__label">
      <div class="label-basic__text">
        The owner's email address you provided is different from the one you used to create your Coverpath account.
        These must match (the owner must control the account). Please confirm the correct email address.
        <br />
        <br />
        {{ mainPolicyOwner.ownerFullName }} is the policy owner. {{ mainPolicyOwner.ownerFirstName }}'s email address
        is:
      </div>
    </div>
    <div class="verify-owner-email__options">
      <div class="radio-button verify-owner-email__radio-button">
        <input
          (click)="setSelection(true)"
          type="radio"
          class="radio-button__input"
          id="owner_email_radio"
          name="email_radio"
          value="ownerEmail"
          checked="checked"
        />
        <label class="radio-button__label" for="owner_email_radio">
          <div class="radio-button__description"></div>
          <div class="radio-button__description">{{ mainPolicyOwner.ownerEmail }}</div>
        </label>
      </div>

      <div class="radio-button">
        <input
          (click)="setSelection(false)"
          type="radio"
          class="radio-button__input"
          id="account_email_radio"
          name="email_radio"
          value="accountEmail"
        />
        <label class="radio-button__label" for="account_email_radio">
          <div class="radio-button__description"></div>
          <div class="radio-button__description">{{ accountEmail }}</div>
        </label>
      </div>
    </div>
    <ng-container *ngIf="isOwnerEmailSelected">
      <button
        class="button button--primary button--yellow button--small verify-owner-email__button"
        (click)="navigateToAccountSettings()"
      >
        UPDATE ACCOUNT SETTINGS...
      </button>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="showVerifyEmailSection">
    <div class="label-basic">
      <div class="label-basic__text" *ngIf="!verifyWithAmc">
        Last, we need to verify the owner's email address, so please check your email and confirm the account by
        entering the code from that email.
      </div>
      <div class="label-basic__text" *ngIf="verifyWithAmc">
        Last, we need to verify the owner's email address, so please check your inbox and click the verification link we
        sent you.
      </div>
    </div>
    <ng-container *ngIf="!verifyWithAmc">
      <div class="entry-field email-code">
        <div class="input-label-container">
          <input
            type="text"
            class="entry-field__input"
            [(ngModel)]="emailCode"
            [class.entry-field--error__input]="isError"
            (change)="clearErrors()"
          />
          <label class="entry-field__label" for="" [class.entry-field--error__label]="isError">Code</label>
        </div>
        <p class="error-message error-message--entry-field" *ngIf="isError">{{ errorMessage }}</p>
        <p class="success-message success-message--entry-field" *ngIf="successMessage">{{ successMessage }}</p>
        <ng-container *ngIf="!isJustVerified">
          <button
            class="button button--primary button--yellow button--small email-code__button"
            (click)="verifyEmail()"
          >
            Verify
          </button>
          <a
            *ngIf="!sentCode; else codeHasBeenSent"
            class="email-code__link email-code__link--underlined"
            (click)="resendCode()"
          >
            Resend Email
          </a>
          <ng-template #codeHasBeenSent>
            <span class="label-basic__subtext email-code__response">Email has been sent.</span>
          </ng-template>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="verifyWithAmc">
      <div class="entry-field email-code">
        <a
          *ngIf="!sentCode; else codeHasBeenSent"
          class="email-code__resend email-code__resend--underlined"
          (click)="resendCode()"
        >
          Resend Email
        </a>
        <ng-template #codeHasBeenSent>
          <span class="label-basic__subtext email-code__response">Email has been sent.</span>
        </ng-template>
      </div>
    </ng-container>
  </ng-container>
</div>
